import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { OrgIntegrations } from 'utils';
import { useAssistantChat } from './useAssistantChat';

const AiAssistantContext = createContext(null);

/**
 * Owns the assistant for the signed-in app: panel visibility plus the chat.
 * Chat state lives here, above the panel, so hiding the panel keeps the
 * conversation; "New chat" or leaving the app is what discards it.
 */
export const AiAssistantProvider = ({ children }) => {
    const { aiAssistant } = OrgIntegrations();
    const [isOpen, setIsOpen] = useState(false);
    const chat = useAssistantChat();

    const open = useCallback(() => setIsOpen(true), []);
    const close = useCallback(() => setIsOpen(false), []);
    const toggle = useCallback(() => setIsOpen((value) => !value), []);

    const value = useMemo(
        () => ({ isEnabled: !!aiAssistant, isOpen: !!aiAssistant && isOpen, open, close, toggle, chat }),
        [aiAssistant, isOpen, open, close, toggle, chat],
    );

    return <AiAssistantContext.Provider value={value}>{children}</AiAssistantContext.Provider>;
};

/** `null` outside the provider, so optional consumers (e.g. the top bar) can render nothing. */
export const useAiAssistant = () => useContext(AiAssistantContext);
